<script>
export default {
  props: {
    additionalClasses: {
      type: String,
      default: ''
    },
    hasCustomHeader: {
      type: Boolean,
      default: false
    },
    hasEmptyTitle: {
      type: Boolean,
      default: false
    },
    hasIcon: {
      type: Boolean,
      default: false
    },
    isBodyFullHeight: {
      type: Boolean,
      default: false
    },
    isBodyInner: {
      type: Boolean,
      default: true
    },
    showBody: {
      type: Boolean,
      default: true
    },
    showFooter: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    }
  },
  computed: {
    nbsp () {
      return '\xa0'
    }
  }
}
</script>
<template>
  <article class="slds-card" :class="additionalClasses">
    <header class="slds-card__header slds-grid" v-if="title || hasEmptyTitle">
      <div class="slds-media slds-media_center slds-has-flexi-truncate">
        <template v-if="hasIcon">
          <div class="slds-media__figure">
            <slot name="icon"></slot>
          </div>
        </template>
        <div class="slds-media__body slds-truncate">
          <h2 class="slds-card__header-title">
            <span class="slds-card__header-link slds-truncate" v-if="hasEmptyTitle">
              {{nbsp}}
            </span>
            <span class="slds-card__header-link slds-truncate" v-else :title="title">
              {{title}}
            </span>
          </h2>
        </div>
      </div>
      <div class="slds-no-flex">
        <slot name="actions"></slot>
      </div>
    </header>
    <header class="slds-card__header slds-grid" v-if="hasCustomHeader">
      <slot name="header"></slot>
      <slot name="actions"></slot>
    </header>
    <div class="slds-card__body" :class="{'slds-card__body_inner': isBodyInner, 'full-height': isBodyFullHeight}" v-if="showBody">
      <slot></slot>
    </div>
    <template v-if="showFooter">
      <div class="slds-card__footer">
        <slot name="footer"></slot>
      </div>
    </template>
  </article>
</template>
<style scoped>
  .full-height {
    height: 100%;
  }
</style>
